// extracted by mini-css-extract-plugin
export default {"label":"InlineData_label__2CsFL","clickable":"InlineData_clickable__KXTqh"};